export const pageUrlGenerator = (page) =>
  `${window.location.protocol}//${window.location.host}${page}`;

export const casinoSection = {
  popularGames: {
    AndarBaharVivo: {
      redirectUrl: "/casino/vivo-andar-bahar",
      code: "",
      casino: "vivo",
      provider: "",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/popular/AndarBahar-Vivo.png",
      alt: "vivo andar bahar",
      name: "Vivo Andar Bahar",
      providerName: "Vivo",
    },
    TeenPattiVivo: {
      redirectUrl: "/casino/vivo-teen-patti",
      code: "",
      casino: "vivo",
      provider: "",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/popular/vivoteenpatti.webp",
      alt: "vivo teen patti",
      name: "Vivo Teen Patti",
      providerName: "Vivo",
    },
    UltimateAndarBahar: {
      redirectUrl: "/casino/ezg-ultimate-andar-bahar",
      code: "328000",
      casino: "ezugi",
      provider: "",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/tvshows/UltimateAndarBahar.png",
      alt: "",
      name: "Ultimate Andar Bahar",
      providerName: "Ezugi",
    },
    AndarBahar: {
      redirectUrl: "/casino/ezg-andar-bahar",
      code: "328000",
      casino: "ezugi",
      provider: "",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/tvshows/AndarBahar.png",
      alt: "",
      name: "Andar Bahar",
      providerName: "Ezugi",
    },
    aviator: {
      redirectUrl: "/casino/spribe/aviator",
      code: "aviator",
      casino: "spribe",
      provider: "aviator",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/popular/aviator.webp",
      alt: "",
      name: "Aviator",
      providerName: "Spribe",
    },
    AutoRoulette: {
      redirectUrl: "/casino/ezg-auto-roulette",
      code: "1000148",
      casino: "ezugi",
      provider: "",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/popular/AutoRoulette.png",
      alt: "",
      name: "Auto Roulette",
      providerName: "Ezugi",
    },
    SpeedRoulette: {
      redirectUrl: "/casino/ezgevo-speed-roulette",
      code: "1000148",
      casino: "ezugi",
      provider: "",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/popular/SpeedRoulette.png",
      alt: "",
      name: "Speed Roulette",
      providerName: "Evolution",
    },
    // LightningRoulette: {
    //   redirectUrl: "/casino/ezgevo-lightning-roulette",
    //   code: "1000148",
    //   casino: "ezugi",
    //   provider: "",
    //   homeUrl: "http://localhost:3000/Casino",
    //   imgUrl: "./images/tvshows/lightningroulette-.jpg",
    //   alt: "",
    //   name: "Lightning Roulette",
    //   providerName: "Evolution",
    // },
    DragonTiger: {
      redirectUrl: "/casino/ezg-dragon-tiger",
      code: "1000148",
      casino: "ezugi",
      provider: "",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/popular/DragonTiger.png",
      alt: "",
      name: "Dragon Tiger",
      providerName: "Ezugi",
    },
    NoCommissionBaccarat: {
      redirectUrl: "/casino/ezg-no-commission-baccarat",
      code: "1000148",
      casino: "ezugi",
      provider: "",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/popular/Baccarat.png",
      alt: "",
      name: "No Commission Baccarat",
      providerName: "Ezugi",
    },
    Lucky7: {
      redirectUrl: "/casino/ezg-lucky-7",
      code: "227103",
      casino: "ezugi",
      provider: "",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/popular/Lucky7.png",
      alt: "",
      name: "Lucky 7",
      providerName: "Ezugi",
    },
    Onedayteenpatti1: {
      redirectUrl: "/casino/ezg-one-day-teen-patti",
      code: "227103",
      casino: "ezugi",
      provider: "",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/poker/onedayteenpatti.webp",
      alt: "",
      name: "One Day Teen Patti",
      providerName: "Ezugi",
    },
    CricketWar: {
      redirectUrl: "/casino/ezg-cricket-war",
      code: "227103",
      casino: "ezugi",
      provider: "",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/tvshows/cricketwar.webp",
      alt: "",
      name: "Cricket War",
      providerName: "Ezugi",
    },
    // CrazyTime: {
    //   redirectUrl: "/casino/ezugi/CrazyTime",
    //   code: "1000148",
    //   casino: "ezugi",
    //   provider: "",
    //   homeUrl: "http://localhost:3000/Casino",
    //   imgUrl: "./images/tvshows/CrazyTime.jpg",
    //   alt: "",
    //   name: "Crazy Time",
    //   providerName: "Evolution",
    // },
  },

  AndarBahar: {
    OTTAndarBahar: {
      redirectUrl: "/casino/ezg-casino-marina-andar-bahar",
      code: "328000",
      casino: "ezugi",
      provider: "",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/tvshows/OttAndarBahar.png",
      alt: "",
      name: "OTT Andar Bahar",
      providerName: "Ezugi",
    },
    AndarBahar: {
      redirectUrl: "/casino/ezg-andar-bahar",
      code: "328000",
      casino: "ezugi",
      provider: "",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/tvshows/AndarBahar.png",
      alt: "",
      name: "Andar Bahar",
      providerName: "Ezugi",
    },
    UltimateAndarBahar: {
      redirectUrl: "/casino/ezg-ultimate-andar-bahar",
      code: "328000",
      casino: "ezugi",
      provider: "",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/tvshows/UltimateAndarBahar.png",
      alt: "",
      name: "Ultimate Andar Bahar",
      providerName: "Ezugi",
    },
  },

  roulettetab: {
    AmericanRouletteEvo: {
      redirectUrl: "/casino/ezg-first-person-american-roulette",
      code: "",
      casino: "evolution",
      provider: "",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/roulette/new/AmericanRoulette-Evo1.webp",
      alt: "evolution american roulette",
      name: "American Roulette Evo",
      providerName: "Evolution",
    },
    AutoRoulette: {
      redirectUrl: "/casino/ezg-auto-roulette",
      code: "",
      casino: "evolution",
      provider: "",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/roulette/new/AutoRoulette.webp",
      alt: "evolution auto roulette",
      name: "Auto Roulette",
      providerName: "Evolution",
    },
    AutoRouletteEvo: {
      redirectUrl: "/casino/ezgevo-speed-auto-roulette",
      code: "",
      casino: "evolution",
      provider: "",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/roulette/new/AutoRoulette-Evo.webp",
      alt: "evolution auto roulette evo",
      name: "Auto Roulette Evo",
      providerName: "Evolution",
    },
    CasinoMarinaRoulette1: {
      redirectUrl: "/casino/ezg-casino-marina-roulette-1",
      code: "",
      casino: "marina",
      provider: "",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/roulette/new/CasinoMarinaRoulette1.webp",
      alt: "marina casino roulette 1",
      name: "Casino Marina Roulette 1",
      providerName: "Marina",
    },
    CasinoMarinaRoulette2: {
      redirectUrl: "/casino/ezg-casino-marina-roulette-2",
      code: "",
      casino: "marina",
      provider: "",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/roulette/new/CasinoMarinaRoulette2.webp",
      alt: "marina casino roulette 2",
      name: "Casino Marina Roulette 2",
      providerName: "Marina",
    },
    CricketAutoRoulette: {
      redirectUrl: "/casino/ezg-cricket-auto-roulette",
      code: "",
      casino: "cricket",
      provider: "",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/roulette/new/CricketAutoROulette.webp",
      alt: "cricket auto roulette",
      name: "Cricket Auto Roulette",
      providerName: "Cricket",
    },
    DiamondRoulette: {
      redirectUrl: "/casino/ezg-diamond-roulette",
      code: "",
      casino: "diamond",
      provider: "",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/roulette/new/DiamondROulette.webp",
      alt: "diamond roulette",
      name: "Diamond Roulette",
      providerName: "Diamond",
    },
    DoubleBallRoulette: {
      redirectUrl: "/casino/ezgevo-double-ball-roulette",
      code: "",
      casino: "double",
      provider: "",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/roulette/new/DOubleBallRoulette.webp",
      alt: "double ball roulette",
      name: "Double Ball Roulette",
      providerName: "Double",
    },
    DragonaraRoulette: {
      redirectUrl: "/casino/ezgevo-dragonara-roulette",
      code: "",
      casino: "dragonara",
      provider: "",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/roulette/new/DragonaraRoulette.webp",
      alt: "dragonara roulette",
      name: "Dragonara Roulette",
      providerName: "Dragonara",
    },
    EuropeanAutoRoulette: {
      redirectUrl: "/casino/vivo-european-auto-roulette",
      code: "",
      casino: "evolution",
      provider: "",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/roulette/new/EuropeanAutoROulette.webp",
      alt: "evolution european auto roulette",
      name: "European Auto Roulette",
      providerName: "Evolution",
    },
    FirstpersonAmericanRoulette: {
      redirectUrl: "/casino/ezg-first-person-american-roulette",
      code: "",
      casino: "firstperson",
      provider: "",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/roulette/new/FirstpersonAmericanRoulette.webp",
      alt: "firstperson american roulette",
      name: "Firstperson American Roulette",
      providerName: "Firstperson",
    },
    FirstPersonAmericanRouletteEvo: {
      redirectUrl: "/casino/ezgevo-first-person-american-roulette",
      code: "",
      casino: "evolution",
      provider: "",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/roulette/new/FirstPersonAmericanRoulette-Evo.webp",
      alt: "evolution firstperson american roulette",
      name: "FirstPerson American Roulette Evo",
      providerName: "Evolution",
    },
    FootballAutoRoulette: {
      redirectUrl: "/casino/ezg-football-auto-roulette",
      code: "",
      casino: "football",
      provider: "",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/roulette/new/FootballAutoRoulette.webp",
      alt: "football auto roulette",
      name: "Football Auto Roulette",
      providerName: "Football",
    },
    FootballStudioRoulette: {
      redirectUrl: "/casino/ezgevo-football-studio-roulette",
      code: "",
      casino: "football",
      provider: "",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/roulette/new/FootballStudioRoulette.webp",
      alt: "football studio roulette",
      name: "Football Studio Roulette",
      providerName: "Football",
    },
    // FrenchRoulette: {
    //   redirectUrl: "/casino/evo-french-roulette-gold",
    //   code: "",
    //   casino: "evolution",
    //   provider: "",
    //   homeUrl: "http://localhost:3000/Casino",
    //   imgUrl: "./images/roulette/new/FrenchRoulette.webp",
    //   alt: "french roulette",
    //   name: "French Roulette",
    //   providerName: "Evolution",
    // },
    // GalaxyRoulette: {
    //   redirectUrl: "/casino/qt-galaxy-roulette",
    //   code: "",
    //   casino: "galaxy",
    //   provider: "",
    //   homeUrl: "http://localhost:3000/Casino",
    //   imgUrl: "./images/roulette/new/GalaxyRoulette.webp",
    //   alt: "galaxy roulette",
    //   name: "Galaxy Roulette",
    //   providerName: "Galaxy",
    // },
    InstantRoulette: {
      redirectUrl: "/casino/ezgevo-instant-roulette",
      code: "",
      casino: "evolution",
      provider: "",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/roulette/new/InstantRoulette.webp",
      alt: "instant roulette",
      name: "Instant Roulette",
      providerName: "Evolution",
    },
    ItalianRoulette: {
      redirectUrl: "/casino/ezg-italian-roulette",
      code: "",
      casino: "italian",
      provider: "",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/roulette/new/ItalianRoulette.webp",
      alt: "italian roulette",
      name: "Italian Roulette",
      providerName: "Italian",
    },
    LasVegasRoulette: {
      redirectUrl: "/casino/vivo-las-vegas-roulette",
      code: "",
      casino: "lasvegas",
      provider: "",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/roulette/new/LasVegasRoulette.webp",
      alt: "las vegas roulette",
      name: "Las Vegas Roulette",
      providerName: "Las Vegas",
    },
    LightningRoulette: {
      redirectUrl: "/casino/ezgevo-lightning-roulette",
      code: "",
      casino: "evolution",
      provider: "",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/roulette/new/LightningRoulette.webp",
      alt: "lightning roulette",
      name: "Lightning Roulette",
      providerName: "Evolution",
    },
    NamasteRoulette: {
      redirectUrl: "/casino/ezg-namaste-roulette",
      code: "",
      casino: "namaste",
      provider: "",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/roulette/new/NamasteRoulette.webp",
      alt: "namaste roulette",
      name: "Namaste Roulette",
      providerName: "Namaste",
    },
    Oracle360Roulette: {
      redirectUrl: "/casino/ezg-oracle-360-roulette",
      code: "",
      casino: "oracle",
      provider: "",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/roulette/new/Oracle360Roulette.webp",
      alt: "oracle 360 roulette",
      name: "Oracle 360 Roulette",
      providerName: "Oracle",
    },
    OracleBlazeRoulette: {
      redirectUrl: "/casino/vivo-oracle-blaze-roulette",
      code: "",
      casino: "oracle",
      provider: "",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/roulette/new/OracleBlazeRoulette.webp",
      alt: "oracle blaze roulette",
      name: "Oracle Blaze Roulette",
      providerName: "Oracle",
    },
    PortomasoRoulette: {
      redirectUrl: "/casino/ezg-portomaso-roulette-2",
      code: "",
      casino: "portomaso",
      provider: "",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/roulette/new/ProtomasoRoulette.webp",
      alt: "portomaso roulette",
      name: "Portomaso Roulette",
      providerName: "Portomaso",
    },
    RoletaDaSorte: {
      redirectUrl: "/casino/ezg-roleta-da-sorte",
      code: "",
      casino: "brazil",
      provider: "",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/roulette/new/RoletaDaSorte.webp",
      alt: "roleta da sorte",
      name: "Roleta Da Sorte",
      providerName: "Brazil",
    },
    RuletaDelSol: {
      redirectUrl: "/casino/ezg-ruleta-del-sol",
      code: "",
      casino: "brazil",
      provider: "",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/roulette/new/RoletaDelSol.webp",
      alt: "ruleta del sol",
      name: "Ruleta Del Sol",
      providerName: "Brazil",
    },
    Roulette: {
      redirectUrl: "/casino/ezg-speed-roulette",
      code: "",
      casino: "generic",
      provider: "",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/roulette/new/Roulette.webp",
      alt: "roulette",
      name: "Roulette",
      providerName: "Generic",
    },
    RouletteAura: {
      redirectUrl: "/casino/qtechvivogaming-roulette-auto",
      code: "",
      casino: "generic",
      provider: "",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/roulette/new/Roulette-Aura.webp",
      alt: "roulette aura",
      name: "Roulette Aura",
      providerName: "Generic",
    },
    RussianRoulette: {
      redirectUrl: "/casino/ezg-russian-roulette",
      code: "",
      casino: "russian",
      provider: "",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/roulette/new/RUssianRoulette.webp",
      alt: "russian roulette",
      name: "Russian Roulette",
      providerName: "Russian",
    },
    SkylineRoulette: {
      redirectUrl: "/casino/ezg-skyline-roulette",
      code: "",
      casino: "skyline",
      provider: "",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/roulette/new/SkylineRoulette.webp",
      alt: "skyline roulette",
      name: "Skyline Roulette",
      providerName: "Skyline",
    },
    SpanishRoulette: {
      redirectUrl: "/casino/ezg-spanish-roulette",
      code: "",
      casino: "spanish",
      provider: "",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/roulette/new/SpanishRoulette.webp",
      alt: "spanish roulette",
      name: "Spanish Roulette",
      providerName: "Spanish",
    },
    SpeedAutoRoulette: {
      redirectUrl: "/casino/ezg-speed-auto-roulette",
      code: "",
      casino: "speed",
      provider: "",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/roulette/new/SpeedAutoROulette.webp",
      alt: "speed auto roulette",
      name: "Speed Auto Roulette",
      providerName: "Speed",
    },
    SpeedAutoRouletteEvo: {
      redirectUrl: "/casino/ezgevo-speed-auto-roulette",
      code: "",
      casino: "evolution",
      provider: "",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/roulette/new/SpeedAutoRoulette-Evo.webp",
      alt: "evolution speed auto roulette",
      name: "Speed Auto Roulette Evo",
      providerName: "Evolution",
    },
    SpeedRoulette: {
      redirectUrl: "/casino/ezg-speed-roulette",
      code: "",
      casino: "speed",
      provider: "",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/roulette/new/SpeedRoulette.webp",
      alt: "speed roulette",
      name: "Speed Roulette",
      providerName: "Speed",
    },
    SpeedRouletteEvo: {
      redirectUrl: "/casino/ezgevo-speed-roulette",
      code: "",
      casino: "evolution",
      provider: "",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/roulette/new/SpeedRoulette-Evo.webp",
      alt: "evolution speed roulette",
      name: "Speed Roulette Evo",
      providerName: "Evolution",
    },
    TurkishRoulette: {
      redirectUrl: "/casino/ezg-turkish-roulette",
      code: "",
      casino: "turkish",
      provider: "",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/roulette/new/TurkishRoulette.webp",
      alt: "turkish roulette",
      name: "Turkish Roulette",
      providerName: "Turkish",
    },
    TurkishLightningRoulette: {
      redirectUrl: "/casino/ezgevo-turkish-lightning-roulette",
      code: "",
      casino: "turkish",
      provider: "",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/roulette/new/TurkishLightningROulette.webp",
      alt: "turkish lightning roulette",
      name: "Turkish Lightning Roulette",
      providerName: "Turkish",
    },
    UltimateRoulette: {
      redirectUrl: "/casino/ezg-ultimate-roulette",
      code: "",
      casino: "ultimate",
      provider: "",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/roulette/new/UltimateRoulette.webp",
      alt: "ultimate roulette",
      name: "Ultimate Roulette",
      providerName: "Ultimate",
    },
    VARoulette: {
      redirectUrl: "/casino/vivo-va-roulette",
      code: "",
      casino: "va",
      provider: "",
      imgUrl: "./images/roulette/new/VARoulette.webp",
      name: "VA Roulette",
    },
  },

  dragontiger: {
    DragonTiger: {
      redirectUrl: "/casino/ezg-dragon-tiger",
      code: "",
      casino: "",
      provider: "",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/dragonTiger/new/DragonTiger.webp",
      alt: "Dragon Tiger",
      name: "Dragon Tiger",
      providerName: "",
    },
    DragonTigerAura: {
      redirectUrl: "/casino/aura-dragon-tiger",
      code: "",
      casino: "",
      provider: "",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/dragonTiger/new/DragonTiger-Aura.webp",
      alt: "Dragon Tiger Aura",
      name: "Dragon Tiger Aura",
      providerName: "",
    },
    DragonTigerDaSorte: {
      redirectUrl: "/casino/ezg-dragon-tiger-da-sorte",
      code: "",
      casino: "",
      provider: "",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/dragonTiger/new/DragonTigerDaSorte.webp",
      alt: "Dragon Tiger Da Sorte",
      name: "Dragon Tiger Da Sorte",
      providerName: "",
    },
    DragonTigerEvo: {
      redirectUrl: "/casino/ezgevo-dragon-tiger-evo",
      code: "",
      casino: "",
      provider: "",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/dragonTiger/new/DragonTiger-Evo.webp",
      alt: "Dragon Tiger Evo",
      name: "Dragon Tiger Evo",
      providerName: "",
    },
    DragonTigerFirstPerson: {
      redirectUrl: "/casino/ezgevo-first-person-dragon-tiger",
      code: "",
      casino: "",
      provider: "",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/dragonTiger/new/DragonTigerFirstPerson.webp",
      alt: "Dragon Tiger First Person",
      name: "Dragon Tiger First Person",
      providerName: "",
    },

    RNGDragonTiger: {
      redirectUrl: "/casino/sn-rng-dragon-tiger",
      code: "",
      casino: "",
      provider: "",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/dragonTiger/new/RNGDragonTiger.webp",
      alt: "RNG Dragon Tiger",
      name: "RNG Dragon Tiger",
      providerName: "",
    },
    RNGDragonTiger2020: {
      redirectUrl: "/casino/sn-rng-dragon-tiger-2020",
      code: "",
      casino: "",
      provider: "",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/dragonTiger/new/RNGDragonTiger2020.webp",
      alt: "RNG Dragon Tiger 2020",
      name: "RNG Dragon Tiger 2020",
      providerName: "",
    },
    SupernovaDragonTiger: {
      redirectUrl: "/casino/sn-dragon-tiger",
      code: "",
      casino: "",
      provider: "",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/dragonTiger/new/Supernowa-DragonTiger.webp",
      alt: "Supernova Dragon Tiger",
      name: "Supernova Dragon Tiger",
      providerName: "",
    },
    VADragonTiger: {
      redirectUrl: "/casino/vivo-dragon-tiger",
      code: "",
      casino: "",
      provider: "",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/dragonTiger/new/VADragonTiger.webp",
      alt: "VA Dragon Tiger",
      name: "VA Dragon Tiger",
      providerName: "",
    },
    VirtualDragonTiger: {
      redirectUrl: "/casino/qtechbeterlive-virtual-dragon-tiger",
      code: "",
      casino: "",
      provider: "",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/dragonTiger/new/VirtualDragonTiger.webp",
      alt: "Virtual Dragon Tiger",
      name: "Virtual Dragon Tiger",
      providerName: "",
    },
    VivoDragonTiger: {
      redirectUrl: "/casino/vivo-dragon-tiger",
      code: "",
      casino: "",
      provider: "",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/dragonTiger/new/VivoDragonTiger.webp",
      alt: "Vivo Dragon Tiger",
      name: "Vivo Dragon Tiger",
      providerName: "",
    },
  },

  baccarattab: {
    _29CardsBaccarat: {
      redirectUrl: "/casino/aura-29-card-baccarat",
      code: "",
      casino: "",
      provider: "",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/baccarat/new/29CardsBaccarat.webp",
      alt: "29 Cards Baccarat",
      name: "29 Cards Baccarat",
      providerName: "",
    },
    Baccarat: {
      redirectUrl: "/casino/ezg-baccarat",
      code: "",
      casino: "",
      provider: "",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/baccarat/new/Baccarat.webp",
      alt: "Baccarat",
      name: "Baccarat",
      providerName: "",
    },
    BaccaratAura: {
      redirectUrl: "/casino/aura-baccarat",
      code: "",
      casino: "",
      provider: "",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/baccarat/new/Baccarat-Aura.webp",
      alt: "Baccarat Aura",
      name: "Baccarat Aura",
      providerName: "",
    },
    BaccaratB: {
      redirectUrl: "/casino/ezgevo-baccarat-b",
      code: "",
      casino: "",
      provider: "",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/baccarat/new/BaccaratB.webp",
      alt: "Baccarat B",
      name: "Baccarat B",
      providerName: "",
    },
    // BaccaratC: {
    //   redirectUrl: "/casino/ezgevo-baccarat-c",
    //   code: "",
    //   casino: "",
    //   provider: "",
    //   homeUrl: "http://localhost:3000/Casino",
    //   imgUrl: "./images/baccarat/new/BaccaratC.webp",
    //   alt: "Baccarat C",
    //   name: "Baccarat C",
    //   providerName: "",
    // },
    BaccaratE: {
      redirectUrl: "/casino/ezgevo-speed-baccarat-e",
      code: "",
      casino: "",
      provider: "",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/baccarat/new/baccaratE.webp",
      alt: "Baccarat E",
      name: "Baccarat E",
      providerName: "",
    },
    BaccaratSqueeze: {
      redirectUrl: "/casino/ezgevo-baccarat-squeeze",
      code: "",
      casino: "",
      provider: "",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/baccarat/new/BaccaratSqueeze.webp",
      alt: "Baccarat Squeeze",
      name: "Baccarat Squeeze",
      providerName: "",
    },
    BaccaratSupernova: {
      redirectUrl: "/casino/sn-baccarat",
      code: "",
      casino: "",
      provider: "",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/baccarat/new/Baccarat_Supernowa.webp",
      alt: "Baccarat Supernova",
      name: "Baccarat Supernova",
      providerName: "",
    },
    CasinoMarinaBaccarat1: {
      redirectUrl: "/casino/ezg-casino-marina-baccarat-1",
      code: "",
      casino: "",
      provider: "",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/baccarat/new/CasinoMarinaBaccarat1.webp",
      alt: "Casino Marina Baccarat 1",
      name: "Casino Marina Baccarat 1",
      providerName: "",
    },
    CasinoMarinaBaccarat2: {
      redirectUrl: "/casino/ezg-casino-marina-baccarat-2",
      code: "",
      casino: "",
      provider: "",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/baccarat/new/CasinoMarinaBaccarat2.webp",
      alt: "Casino Marina Baccarat 2",
      name: "Casino Marina Baccarat 2",
      providerName: "",
    },
    CasinoMarinaBaccarat3: {
      redirectUrl: "/casino/ezg-casino-marina-baccarat-3",
      code: "",
      casino: "",
      provider: "",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/baccarat/new/CasinoMarinaBaccarat3.webp",
      alt: "Casino Marina Baccarat 3",
      name: "Casino Marina Baccarat 3",
      providerName: "",
    },
    CasinoMarinaBaccarat4: {
      redirectUrl: "/casino/ezg-casino-marina-baccarat-4",
      code: "",
      casino: "",
      provider: "",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/baccarat/new/CasinoMarinaBaccarat4.webp",
      alt: "Casino Marina Baccarat 4",
      name: "Casino Marina Baccarat 4",
      providerName: "",
    },
    FirstPersonBaccarat: {
      redirectUrl: "/casino/ezgevo-first-person-baccarat",
      code: "",
      casino: "",
      provider: "",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/baccarat/new/FirstPersonBaccarat.webp",
      alt: "First Person Baccarat",
      name: "First Person Baccarat",
      providerName: "",
    },
    FirstPersonGoldenWealthBaccarat: {
      redirectUrl: "/casino/	ezgevo-first-person-golden-wealth-baccarat",
      code: "",
      casino: "",
      provider: "",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/baccarat/new/FirstPersonGoldenWealthBaccarat.webp",
      alt: "First Person Golden Wealth Baccarat",
      name: "First Person Golden Wealth Baccarat",
      providerName: "",
    },
    FirstPersonLightningBaccarat: {
      redirectUrl: "/casino/ezgevo-first-person-lightning-baccarat",
      code: "",
      casino: "",
      provider: "",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/baccarat/new/FirstPersonLightningBaccarat.webp",
      alt: "First Person Lightning Baccarat",
      name: "First Person Lightning Baccarat",
      providerName: "",
    },
    Fortune6Baccarat: {
      redirectUrl: "/casino/ezg-fortune-baccarat",
      code: "",
      casino: "",
      provider: "",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/baccarat/new/Fortune6Baccarat.webp",
      alt: "Fortune 6 Baccarat",
      name: "Fortune 6 Baccarat",
      providerName: "",
    },
    FortuneBaccarat: {
      redirectUrl: "/casino/ezg-fortune-baccarat",
      code: "",
      casino: "",
      provider: "",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/baccarat/new/FortuneBaccarat.webp",
      alt: "Fortune Baccarat",
      name: "Fortune Baccarat",
      providerName: "",
    },
    GalaxyBaccarat1: {
      redirectUrl: "/casino/vivo-galaxy-baccarat-1",
      code: "",
      casino: "",
      provider: "",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/baccarat/new/GalaxyBaccarat1.webp",
      alt: "Galaxy Baccarat 1",
      name: "Galaxy Baccarat 1",
      providerName: "",
    },
    GalaxyBaccarat2: {
      redirectUrl: "/casino/vivo-galaxy-baccarat-2",
      code: "",
      casino: "",
      provider: "",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/baccarat/new/GalaxyBaccarat2.webp",
      alt: "Galaxy Baccarat 2",
      name: "Galaxy Baccarat 2",
      providerName: "",
    },
    GalaxyBaccarat3: {
      redirectUrl: "/casino/vivo-galaxy-baccarat-3",
      code: "",
      casino: "",
      provider: "",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/baccarat/new/GalaxyBaccarat3.webp",
      alt: "Galaxy Baccarat 3",
      name: "Galaxy Baccarat 3",
      providerName: "",
    },
    GoldenWealthBaccarat: {
      redirectUrl: "/casino/ezgevo-golden-wealth-baccarat",
      code: "",
      casino: "",
      provider: "",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/baccarat/new/GoldenWealthBaccarat.webp",
      alt: "Golden Wealth Baccarat",
      name: "Golden Wealth Baccarat",
      providerName: "",
    },
    KnockOutBaccarat: {
      redirectUrl: "/casino/ezg-knockout-baccarat",
      code: "",
      casino: "",
      provider: "",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/baccarat/new/KnockOutBaccarat.webp",
      alt: "Knock Out Baccarat",
      name: "Knock Out Baccarat",
      providerName: "",
    },
    LightningBaccarat: {
      redirectUrl: "/casino/ezgevo-lightning-baccarat",
      code: "",
      casino: "",
      provider: "",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/baccarat/new/LightningBaccarat.webp",
      alt: "Lightning Baccarat",
      name: "Lightning Baccarat",
      providerName: "",
    },
    MacauBaccarat: {
      redirectUrl: "/casino/vivo-macau-baccarat",
      code: "",
      casino: "",
      provider: "",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/baccarat/new/MacauBaccarat.webp",
      alt: "Macau Baccarat",
      name: "Macau Baccarat",
      providerName: "",
    },
    NoCommissionBaccarat: {
      redirectUrl: "/casino/ezg-no-commission-baccarat",
      code: "",
      casino: "",
      provider: "",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/baccarat/new/NoCommissionBaccarat.webp",
      alt: "No Commission Baccarat",
      name: "No Commission Baccarat",
      providerName: "",
    },
    NoCommissionBaccaratA: {
      redirectUrl: "/casino/ezgevo-no-commission-speed-baccarat-a",
      code: "",
      casino: "",
      provider: "",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/baccarat/new/NoCommissionBaccaratA.webp",
      alt: "No Commission Baccarat A",
      name: "No Commission Baccarat A",
      providerName: "",
    },
    NoCommissionBaccaratB: {
      redirectUrl: "/casino/ezgevo-no-commission-speed-baccarat-b",
      code: "",
      casino: "",
      provider: "",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/baccarat/new/NoCommissionBaccaratB.webp",
      alt: "No Commission Baccarat B",
      name: "No Commission Baccarat B",
      providerName: "",
    },
    NoCommissionBaccaratC: {
      redirectUrl: "/casino/ezgevo-no-commission-speed-baccarat-c",
      code: "",
      casino: "",
      provider: "",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/baccarat/new/NoCommissionBaccaratC.webp",
      alt: "No Commission Baccarat C",
      name: "No Commission Baccarat C",
      providerName: "",
    },
    NoCommissionBaccaratD: {
      redirectUrl: "/casino/ezgevo-no-commission-speed-baccarat-d",
      code: "",
      casino: "",
      provider: "",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/baccarat/new/NoCommissionBaccaratD.webp",
      alt: "No Commission Baccarat D",
      name: "No Commission Baccarat D",
      providerName: "",
    },
    NoCommissionBaccaratEvo: {
      redirectUrl: "/casino/ezgevo-no-commission-baccarat-evo",
      code: "",
      casino: "",
      provider: "",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/baccarat/new/NoCommissionBaccarat-Evo.webp",
      alt: "No Commission Baccarat Evo",
      name: "No Commission Baccarat Evo",
      providerName: "",
    },
    NoCommissionOverUnderBaccarat: {
      redirectUrl: "/casino/ezg-no-commission-over-under-baccarat",
      code: "",
      casino: "",
      provider: "",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/baccarat/new/NoCommissionOverUnderBaccarat.webp",
      alt: "No Commission Over Under Baccarat",
      name: "No Commission Over Under Baccarat",
      providerName: "",
    },
    NoCommissionVipSpeedCricketBaccarat: {
      redirectUrl: "/casino/ezg-vip-no-commission-speed-cricket-baccarat",
      code: "",
      casino: "",
      provider: "",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/baccarat/new/nocommissionvipspeedcricketBaccarat.webp",
      alt: "No Commission VIP Speed Cricket Baccarat",
      name: "No Commission VIP Speed Cricket Baccarat",
      providerName: "",
    },
    OverUnderBaccarat: {
      redirectUrl: "/casino/ezg-over-under-baccarat",
      code: "",
      casino: "",
      provider: "",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/baccarat/new/OverUnderBaccarat.webp",
      alt: "Over Under Baccarat",
      name: "Over Under Baccarat",
      providerName: "",
    },
    RNGBaccarat: {
      redirectUrl: "/casino/sn-rng-baccarat",
      code: "",
      casino: "",
      provider: "",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/baccarat/new/RNGBaccarat.webp",
      alt: "RNG Baccarat",
      name: "RNG Baccarat",
      providerName: "",
    },
    SpeedBaccaratA: {
      redirectUrl: "/casino/ezgevo-speed-baccarat-a",
      code: "",
      casino: "",
      provider: "",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/baccarat/new/SpeedBaccaratA.webp",
      alt: "Speed Baccarat A",
      name: "Speed Baccarat A",
      providerName: "",
    },
    SpeedBaccaratB: {
      redirectUrl: "/casino/ezgevo-speed-baccarat-b",
      code: "",
      casino: "",
      provider: "",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/baccarat/new/SpeedBaccaratB.webp",
      alt: "Speed Baccarat B",
      name: "Speed Baccarat B",
      providerName: "",
    },
    SpeedBaccaratC: {
      redirectUrl: "/casino/ezgevo-speed-baccarat-c",
      code: "",
      casino: "",
      provider: "",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/baccarat/new/SpeedbaccaratCc.webp",
      alt: "Speed Baccarat C",
      name: "Speed Baccarat C",
      providerName: "",
    },
    SpeedBaccaratD: {
      redirectUrl: "/casino/ezgevo-speed-baccarat-d",
      code: "",
      casino: "",
      provider: "",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/baccarat/new/SpeedbaccaratDd.webp",
      alt: "Speed Baccarat D",
      name: "Speed Baccarat D",
      providerName: "",
    },
    SpeedBaccaratE: {
      redirectUrl: "/casino/ezgevo-speed-baccarat-e",
      code: "",
      casino: "",
      provider: "",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/baccarat/new/SpeedbaccaratEe.webp",
      alt: "Speed Baccarat E",
      name: "Speed Baccarat E",
      providerName: "",
    },
    SpeedCricketBaccarat: {
      redirectUrl: "/casino/ezg-speed-cricket-baccarat",
      code: "",
      casino: "",
      provider: "",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/baccarat/new/SpeedCricketBaccarat.webp",
      alt: "Speed Cricket Baccarat",
      name: "Speed Cricket Baccarat",
      providerName: "",
    },
    SpeedFortuneBaccarat: {
      redirectUrl: "/casino/ezg-speed-fortune-baccarat",
      code: "",
      casino: "",
      provider: "",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/baccarat/new/SpeedFortuneBaccarat.webp",
      alt: "Speed Fortune Baccarat",
      name: "Speed Fortune Baccarat",
      providerName: "",
    },
    Super6Baccarat: {
      redirectUrl: "/casino/ezg-super-6-baccarat",
      code: "",
      casino: "",
      provider: "",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/baccarat/new/Super6Baccarat.webp",
      alt: "Super 6 Baccarat",
      name: "Super 6 Baccarat",
      providerName: "",
    },
    VABaccarat: {
      redirectUrl: "/casino/qtechvivogaming-va-baccarat-1",
      code: "",
      casino: "",
      provider: "",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/baccarat/new/VABaccarat.webp",
      alt: "VA Baccarat",
      name: "VA Baccarat",
      providerName: "",
    },
    VIPFortuneBaccarat: {
      redirectUrl: "/casino/ezg-vip-fortune-baccarat",
      code: "",
      casino: "",
      provider: "",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/baccarat/new/VIPFortuneBaccarat.webp",
      alt: "VIP Fortune Baccarat",
      name: "VIP Fortune Baccarat",
      providerName: "",
    },
  },

  tvShows: {
    Blackjack: {
      redirectUrl: "/casino/ezg-blackjack-1",
      code: "201",
      casino: "ezugi",
      provider: "",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/blackjack/blackjack.jpg",
      alt: "",
      name: "Blackjack",
      providerName: "Ezugi",
    },
    LightningDice: {
      redirectUrl: "/casino/ezgevo-lightning-dice",
      code: "1000148",
      casino: "ezugi",
      provider: "",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/tvshows/lightningdice.jpg",
      alt: "",
      name: "Lightning Dice",
      providerName: "Evolution",
    },
    CrazyTime: {
      redirectUrl: "/casino/ezugi/CrazyTime",
      code: "1000148",
      casino: "ezugi",
      provider: "",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/tvshows/CrazyTime.jpg",
      alt: "",
      name: "Crazy Time",
      providerName: "Evolution",
    },
    Megaball: {
      redirectUrl: "/casino/ezugi/Megaball",
      code: "1000141",
      casino: "ezugi",
      provider: "",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/tvshows/Megaball.jpg",
      alt: "",
      name: "Megaball",
      providerName: "Evolution",
    },
  },

  blackjacktab: {
    BlackjackA: {
      redirectUrl: "/casino/ezgevo-blackjack-a",
      code: "",
      casino: "",
      provider: "",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/blackjack/new/BlackjackA.webp",
      alt: "Blackjack A",
      name: "Blackjack A",
      providerName: "",
    },
    blackjackD: {
      redirectUrl: "/casino/ezgevo-blackjack-d",
      code: "",
      casino: "",
      provider: "",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/blackjack/new/blackjackD.webp",
      alt: "Blackjack D",
      name: "Blackjack D",
      providerName: "",
    },
    BlackjackDaSorte: {
      redirectUrl: "/casino/ezg-blackjack-da-sorte",
      code: "",
      casino: "",
      provider: "",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/blackjack/new/BlackjackDaSorte.webp",
      alt: "Blackjack Da Sorte",
      name: "Blackjack Da Sorte",
      providerName: "",
    },
    BlackjackParty: {
      redirectUrl: "/casino/ezgevo-blackjack-party",
      code: "",
      casino: "",
      provider: "",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/blackjack/new/BlackjackParty.webp",
      alt: "Blackjack Party",
      name: "Blackjack Party",
      providerName: "",
    },
    BlackjackSilverA: {
      redirectUrl: "/casino/ezgevo-blackjack-silver-a",
      code: "",
      casino: "",
      provider: "",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/blackjack/new/BlackjackSilverA.webp",
      alt: "Blackjack Silver A",
      name: "Blackjack Silver A",
      providerName: "",
    },
    BlackjackVIP10: {
      redirectUrl: "/casino/ezgevo-blackjack-vip-10",
      code: "",
      casino: "",
      provider: "",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/blackjack/new/BlackjackVIP10.webp",
      alt: "Blackjack VIP 10",
      name: "Blackjack VIP 10",
      providerName: "",
    },
    BlackjackVIPAlpha: {
      redirectUrl: "/casino/ezgevo-blackjack-vip-alpha",
      code: "",
      casino: "",
      provider: "",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/blackjack/new/BlackjackVIPAlpha.webp",
      alt: "Blackjack VIP Alpha",
      name: "Blackjack VIP Alpha",
      providerName: "",
    },
    BlackjackVIPBeta: {
      redirectUrl: "/casino/evo-blackjack-vip-beta",
      code: "",
      casino: "",
      provider: "",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/blackjack/new/BlackjackVIPBeta.webp",
      alt: "Blackjack VIP Beta",
      name: "Blackjack VIP Beta",
      providerName: "",
    },
    BlackjackVIPE: {
      redirectUrl: "/casino/ezgevo-blackjack-vip-e",
      code: "",
      casino: "",
      provider: "",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/blackjack/new/BlackjackVIPE.webp",
      alt: "Blackjack VIP E",
      name: "Blackjack VIP E",
      providerName: "",
    },
    BlackjackVIPGamma: {
      redirectUrl: "/casino/ezgevo-blackjack-vip-gamma",
      code: "",
      casino: "",
      provider: "",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/blackjack/new/BlackjackVIPGamma.webp",
      alt: "Blackjack VIP Gamma",
      name: "Blackjack VIP Gamma",
      providerName: "",
    },
    BlackjackVIPL: {
      redirectUrl: "/casino/ezgevo-blackjack-vip-l",
      code: "",
      casino: "",
      provider: "",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/blackjack/new/BlackjackVIPL.webp",
      alt: "Blackjack VIP L",
      name: "Blackjack VIP L",
      providerName: "",
    },
    ClassicSpeedblackjack10: {
      redirectUrl: "/casino/ezgevo-classic-speed-blackjack-10",
      code: "",
      casino: "",
      provider: "",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/blackjack/new/ClassicSpeedblackjack10.webp",
      alt: "Classic Speed Blackjack 10",
      name: "Classic Speed Blackjack 10",
      providerName: "",
    },
    FirstPersonblackjack: {
      redirectUrl: "/casino/ezgevo-first-person-blackjack",
      code: "",
      casino: "",
      provider: "",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/blackjack/new/FirstPersonblackjack.webp",
      alt: "First Person Blackjack",
      name: "First Person Blackjack",
      providerName: "",
    },
    FirstPersonLightningBlackjack: {
      redirectUrl: "/casino/ezgevo-first-person-lightning-blackjack",
      code: "",
      casino: "",
      provider: "",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/blackjack/new/FirstPersonLightningBlackjack.webp",
      alt: "First Person Lightning Blackjack",
      name: "First Person Lightning Blackjack",
      providerName: "",
    },
    GoldBlackjack1: {
      redirectUrl: "/casino/ezg-gold-blackjack-1",
      code: "",
      casino: "",
      provider: "",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/blackjack/new/GoldBlackjack1.webp",
      alt: "Gold Blackjack 1",
      name: "Gold Blackjack 1",
      providerName: "",
    },
    GoldBlackjack3: {
      redirectUrl: "/casino/ezg-gold-blackjack-3",
      code: "",
      casino: "",
      provider: "",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/blackjack/new/GoldBlackjack3.webp",
      alt: "Gold Blackjack 3",
      name: "Gold Blackjack 3",
      providerName: "",
    },
    Infiniteblackjack: {
      redirectUrl: "/casino/ezgevo-infinite-blackjack",
      code: "",
      casino: "",
      provider: "",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/blackjack/new/Infiniteblackjack.webp",
      alt: "Infinite Blackjack",
      name: "Infinite Blackjack",
      providerName: "",
    },
    LasVegasBlackjack: {
      redirectUrl: "/casino/vivo-las-vegas-blackjack",
      code: "",
      casino: "",
      provider: "",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/blackjack/new/LasvegasBlackjacknew.webp",
      alt: "Las Vegas Blackjack",
      name: "Las Vegas Blackjack",
      providerName: "",
    },
    LightningBlackjack: {
      redirectUrl: "/casino/ezgevo-lightning-blackjack",
      code: "",
      casino: "",
      provider: "",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/blackjack/new/LightningBlackjack.webp",
      alt: "Lightning Blackjack",
      name: "Lightning Blackjack",
      providerName: "",
    },
    LimitlessBlackjack: {
      redirectUrl: "/casino/vivo-limitless-blackjack",
      code: "",
      casino: "",
      provider: "",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/blackjack/new/LimitlessBlackjack.webp",
      alt: "Limitless Blackjack",
      name: "Limitless Blackjack",
      providerName: "",
    },
    PowerBlackjack: {
      redirectUrl: "/casino/ezgevo-power-blackjack",
      code: "",
      casino: "",
      provider: "",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/blackjack/new/PowerBlackjack.webp",
      alt: "Power Blackjack",
      name: "Power Blackjack",
      providerName: "",
    },
    RumbaBlackjack1: {
      redirectUrl: "/casino/ezg-rumba-blackjack-1",
      code: "",
      casino: "",
      provider: "",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/blackjack/new/RumbaBlackjack1.webp",
      alt: "Rumba Blackjack 1",
      name: "Rumba Blackjack 1",
      providerName: "",
    },
    RumbaBlackjack4: {
      redirectUrl: "/casino/ezg-rumba-blackjack-4",
      code: "",
      casino: "",
      provider: "",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/blackjack/new/RumbaBlackjack4.webp",
      alt: "Rumba Blackjack 4",
      name: "Rumba Blackjack 4",
      providerName: "",
    },
    SpanishUltimateblackjack: {
      redirectUrl: "/casino/ezg-spanish-unlimited-blackjack",
      code: "",
      casino: "",
      provider: "",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/blackjack/new/SpanishUltimateblackjack.webp",
      alt: "Spanish Ultimate Blackjack",
      name: "Spanish Ultimate Blackjack",
      providerName: "",
    },

    VIPDiamondBlackjack: {
      redirectUrl: "/casino/ezg-vip-diamond-blackjack",
      code: "",
      casino: "",
      provider: "",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/blackjack/new/VIPDiamondBlackjack.webp",
      alt: "VIP Diamond Blackjack",
      name: "VIP Diamond Blackjack",
      providerName: "",
    },
    VIPSurrenderBlackjack: {
      redirectUrl: "/casino/ezg-vip-surrender-blackjack",
      code: "",
      casino: "",
      provider: "",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/blackjack/new/VIPSurrenderBlackjack.webp",
      alt: "VIP Surrender Blackjack",
      name: "VIP Surrender Blackjack",
      providerName: "",
    },
  },

  pokertab: {
    Hand2CasinoHoldem: {
      redirectUrl: "/casino/ezgevo-2-hand-casino-holdem",
      code: "1000073",
      casino: "ezugi",
      provider: "",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/poker/2handcasinoholdem.webp",
      alt: "",
      name: " 2 Hand Casino Holdem",
      providerName: "Evolution",
    },
    BetonTeenPatti: {
      redirectUrl: "/casino/ezg-bet-on-teen-patti",
      code: "227101",
      casino: "ezugi",
      provider: "",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/poker/betonteenpatti.webp",
      alt: "",
      name: "Bet on Teen Patti",
      providerName: "Ezugi",
    },
    // SideBetCity: {
    //   redirectUrl: "/casino/ezugi/SideBetCity",
    //   code: "1000115",
    //   casino: "ezugi",
    //   provider: "",
    //   homeUrl: "http://localhost:3000/Casino",
    //   imgUrl: "./images/poker/Sidebetcity.jpg",
    //   alt: "",
    //   name: "Side Bet City",
    //   providerName: "Evolution",
    // },
    TeenPatti3card: {
      redirectUrl: "/casino/ezg-teen-patti-3-card",
      code: "227100",
      casino: "ezugi",
      provider: "",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/poker/teenpatti3card.webp",
      alt: "",
      name: " Teen Patti 3 Card",
      providerName: "Ezugi",
    },
    TexasHoldembonus: {
      redirectUrl: "/casino/ezgevo-texas-holdem-bonus-poker",
      code: "1000111",
      casino: "ezugi",
      provider: "",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/poker/texasholdem.webp",
      alt: "",
      name: "Texas Holdem Bonus",
      providerName: "Evolution",
    },
    // Ultimatetexasholdem: {
    //   redirectUrl: "/casino/ezugi/Ultimatetexasholdem",
    //   code: "1000151",
    //   casino: "ezugi",
    //   provider: "",
    //   homeUrl: "http://localhost:3000/Casino",
    //   imgUrl: "./images/poker/ultimatetaxasholden.jpg",
    //   alt: "",
    //   name: "Ultimate Texas Holdem",
    //   providerName: "Evolution",
    // },
  },

  spribe: {
    aviator: {
      redirectUrl: "/casino/spribe/aviator",
      code: "aviator",
      casino: "spribe",
      provider: "aviator",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/spribe/Aviator.gif",
      alt: "",
      name: "Aviator",
      providerName: "Spribe",
    },
    mines: {
      redirectUrl: "/casino/spribe/mines",
      code: "mines",
      casino: "spribe",
      provider: "mines",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/spribe/Mines.jpg",
      alt: "",
      name: "Mines",
      providerName: "Spribe",
    },
    goal: {
      redirectUrl: "/casino/spribe/goal",
      code: "goal",
      casino: "spribe",
      provider: "goal",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/spribe/Goal.jpg",
      alt: "",
      name: "Goal",
      providerName: "Spribe",
    },
    dice: {
      redirectUrl: "/casino/spribe/dice",
      code: "dice",
      casino: "spribe",
      provider: "dice",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/spribe/Dice.jpg",
      alt: "",
      name: "Dice",
      providerName: "Spribe",
    },
    plinko: {
      redirectUrl: "/casino/spribe/plinko",
      code: "plinko",
      casino: "spribe",
      provider: "plinko",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/spribe/Plinko.jpg",
      alt: "",
      name: "Plinko",
      providerName: "Spribe",
    },
    miniroulette: {
      redirectUrl: "/casino/spribe/miniroulette",
      code: "mini-roulette",
      casino: "spribe",
      provider: "mini-roulette",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/spribe/MiniROulette.jpg",
      alt: "",
      name: "Mini Roulette",
      providerName: "Spribe",
    },
    hilo: {
      redirectUrl: "/casino/spribe/hilo",
      code: "hi-lo",
      casino: "spribe",
      provider: "hi-lo",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/spribe/Hilo.jpg",
      alt: "",
      name: "Hilo",
      providerName: "Spribe",
    },
  },

  supernowa: {
    RNGCasinoQueen: {
      redirectUrl: "/casino/sn-rng-casino-queen",
      code: "RCQ",
      casino: "wco",
      provider: "SN",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/supernowa/RNGCasinoQueen.jpg",
      alt: "",
      name: "RNG Casino Queen",
      providerName: "Supernowa",
    },
    RNGCasinoQueen2020: {
      redirectUrl: "/casino/sn-rng-casino-queen-2020",
      code: "RCQ20",
      casino: "wco",
      provider: "SN",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/supernowa/RNGCasinoQueen2020.jpg",
      alt: "",
      name: "RNG Casino Queen 2020",
      providerName: "Supernowa",
    },
    RNGCricket2020: {
      redirectUrl: "/casino/sn-rng-cricket-2020",
      code: "RCKT20",
      casino: "wco",
      provider: "SN",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/supernowa/RNGCricket2020.jpg",
      alt: "",
      name: "RNG Cricket 2020",
      providerName: "Supernowa",
    },
    RNGDragonTiger: {
      redirectUrl: "/casino/sn-rng-dragon-tiger",
      code: "VDT",
      casino: "wco",
      provider: "SN",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/supernowa/RNG-Dragon-Tiger.jpg",
      alt: "",
      name: "RNG Dragon Tiger",
      providerName: "Supernowa",
    },
    RNGDragonTiger2020: {
      redirectUrl: "/casino/sn-rng-dragon-tiger-2020",
      code: "VDT20",
      casino: "wco",
      provider: "SN",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/supernowa/RNGDragonTiger2020.jpg",
      alt: "",
      name: "RNG Dragon Tiger 2020",
      providerName: "Supernowa",
    },
    RNGJoker: {
      redirectUrl: "/casino/sn-rng-joker",
      code: "VJKR",
      casino: "wco",
      provider: "SN",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/supernowa/RNGJoker.jpg",
      alt: "",
      name: "RNG Joker",
      providerName: "Supernowa",
    },
    RNGKingRace: {
      redirectUrl: "/casino/sn-rng-king-race",
      code: "VCR",
      casino: "wco",
      provider: "SN",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/supernowa/RNGKingRace.jpg",
      alt: "",
      name: "RNG King Race",
      providerName: "Supernowa",
    },
    RNGLucky7: {
      redirectUrl: "/casino/sn-rng-lucky-7",
      code: "VUD7",
      casino: "wco",
      provider: "SN",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/supernowa/RNGLucky7.jpg",
      alt: "",
      name: "RNG Lucky 7",
      providerName: "Supernowa",
    },
    RNGTeenPatti: {
      redirectUrl: "/casino/sn-rng-teen-patti",
      code: "VTP",
      casino: "wco",
      provider: "SN",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/supernowa/RNGTeenPatti.jpg",
      alt: "",
      name: "RNG Teen Patti",
      providerName: "Supernowa",
    },
    RNGTeenPatti2020: {
      redirectUrl: "/casino/sn-rng-teen-patti-2020",
      code: "VTP20",
      casino: "wco",
      provider: "SN",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/supernowa/RNGTeenPatti2020.jpg",
      alt: "",
      name: "RNG Teen Patti 2020",
      providerName: "Supernowa",
    },
    RNGWorliMatka: {
      redirectUrl: "/casino/sn-rng-worli-matka",
      code: "VWM",
      casino: "wco",
      provider: "SN",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/supernowa/RNGWorliMatka.jpg",
      alt: "",
      name: "RNG Worli Matka",
      providerName: "Supernowa",
    },
  },

  vivo: {
    VABacarat1: {
      redirectUrl: "/casino/vivo-va-bacarat-1",
      imgUrl: "./images/Vivo/VABacarat1.jpg",
      name: "VA Bacarat 1",
      providerName: "Vivo",
    },
    VABacarat2: {
      redirectUrl: "/casino/vivo-va-bacarat-2",
      imgUrl: "./images/Vivo/VABacarat2.jpg",
      name: "VA Bacarat 2",
      providerName: "Vivo",
    },
    VABacarat3: {
      redirectUrl: "/casino/vivo-va-bacarat-3",
      imgUrl: "./images/Vivo/VABacarat3.jpg",
      name: "VA Bacarat 3",
      providerName: "Vivo",
    },
    VABacarat4: {
      redirectUrl: "/casino/vivo-va-bacarat-4",
      imgUrl: "./images/Vivo/VABacarat4.jpg",
      name: "VA Bacarat 4",
      providerName: "Vivo",
    },
    VABacarat5: {
      redirectUrl: "/casino/vivo-va-bacarat-5",
      imgUrl: "./images/Vivo/VABacarat5.jpg",
      name: "VA Bacarat 5",
      providerName: "Vivo",
    },
  },
};
